import React from 'react';
import './Kyc.css';
import TaskAltIcon from '../assets/icons/taskAlt.js';
import PageLayout from './common/PageLayout';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Kyc() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const navigationProps = {
        showPrevious: false,
        nextLabel: t('kycButtonContinue'),
        onNext: () => navigate('/kyc-waiting'),
        align: 'center',
        nextStyleOverride: {
            borderRadius: '8px',
            padding: '14px 40px',
            fontSize: '17px',
            fontWeight: '600',
            width: '100%',
            maxWidth: '360px'
        }
    };

    return (
        <PageLayout currentStep={1} navigationProps={navigationProps} infoText="kycInfoText">
            <div className="kyc-content">
                <div className="secure-verification-container">
                    <div className="sv-content">
                        <h2 className="sv-title">{t('kycTitle')}</h2>
                        <p className="sv-desc">{t('kycDesc')}</p>
                    </div>

                    <div className="sv-why-box">
                        <div className="sv-why-title">{t('kycWhyTitle')}</div>
                        <ul className="sv-why-list">
                            <li><span className="sv-check-icon"><TaskAltIcon /></span> {t('kycWhyItemEuRegulated')}</li>
                            <li><span className="sv-check-icon"><TaskAltIcon /></span> {t('kycWhyItemSecurity')}</li>
                            <li><span className="sv-check-icon"><TaskAltIcon /></span> {t('kycWhyItemSpecialized')}</li>
                            <li><span className="sv-check-icon"><TaskAltIcon /></span> {t('kycWhyItemPrivacy')}</li>
                        </ul>

                        <div className="sv-trusted">
                            <div className="sv-trusted-label">{t('kycTrustedByTitle')}</div>
                            <div className="sv-trusted-logos">
                                <img src="/assets/speedledgerLogo.png" alt="Speedledger" />
                                <img src="/assets/intlyLogo.png" alt="Intly" />
                                <img src="/assets/monitorLogo.png" alt="Monitor ERP" />
                                <img src="/assets/acconomyLogo.png" alt="Acconomy" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

export default Kyc;
